import Divider from "components/v2/Divider/Divider";
import { useFieldArray, useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";

import { ExtractedPackingListTableItem } from "api/models/documentProcessor";
import { ReactComponent as PlusIcon } from "assets/images/iconsV2/plus.svg";
import Button from "components/v2/Button/Button";
import OrganisationForm from "./OrganisationForm";
import PackingListItemForm from "./PackingListItemForm";
import TotalCalculations from "./TotalCalculations";

interface ExtractedPackingListFormProps {
  extractedPackingListDetails: any;
  selectedJob?: ExtractedPackingListTableItem;
}

export default function ExtractedPackingListForm({
  extractedPackingListDetails,
  selectedJob,
}: ExtractedPackingListFormProps) {
  const intl = useIntl();
  const methods = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control: methods.control,
    name: "packing_list",
  });

  const handleRemovePackingListItem = (index: number) => {
    remove(index);
  };

  return (
    <div className="pt-xl">
      <OrganisationForm extractedPackingListDetails={extractedPackingListDetails} />
      <Divider className="py-3xl" />

      <div className="d-flex justify-content-between align-items-center">
        <div className="text-secondary text-lg font-weight-semibold pb-3xl">
          <FormattedMessage id="general.packingList" defaultMessage="Packing List" />
        </div>
        <TotalCalculations />
      </div>

      {fields.map((field, index) => (
        <PackingListItemForm
          key={field.id}
          index={index}
          selectedJob={selectedJob}
          handleRemovePackingListItem={handleRemovePackingListItem}
        />
      ))}
      <Button
        iconLeft={<PlusIcon />}
        label={intl.formatMessage({
          id: "documentParser.uploadPage.reviewDrawer.addPackingItem",
          defaultMessage: "Add packing item",
        })}
        variant="secondary-color"
        className="m-3xl"
        onClick={() => append({})}
      />
    </div>
  );
}

ExtractedPackingListForm.defaultProps = {
  selectedJob: undefined,
};
